export const GET_ERRORS = 'GET_ERRORS';
export const CLEAN_MESSAGES = 'CLEAN_MESSAGES';
export const GET_GENERIC_ERROR = 'GET_GENERIC_ERROR';
export const SET_UPLOAD_ERROR = 'SET_UPLOAD_ERROR';
export const SET_UPLOAD_SUCCESS = 'SET_UPLOAD_SUCCESS';
export const SET_UPLOAD_SUCCESS_WARNING = 'SET_UPLOAD_SUCCESS_WARNING';
